// controls/email.js — version React Composant + JSON Schema native
import React, { useState, useEffect } from "react";
import CommonControls from "./inc/Common";

/**
 * Création d’un champ email conforme JSON Schema draft 2020-12
 */
export function createEmailField() {
  return {
    type: "string",
    format: "email",
    title: "Adresse e-mail",
    minLength: 0,
    maxLength: 255,
    pattern: "",
    "x-ui": "email",
    "x-placeholder": "",
    "x-displayWidth": "",
    "x-inputMode": "email",
  };
}

/**
 * Éditeur du champ e-mail (FieldEditor) — version composant React
 */
export function EditEmailField({ field, onChange }) {
  const [min, setMin] = useState(field.minLength ?? 0);
  const [max, setMax] = useState(field.maxLength ?? 255);
  const [pattern, setPattern] = useState(field.pattern || "");
  const [placeholder, setPlaceholder] = useState(field["x-placeholder"] || "");
  const [displayWidth, setDisplayWidth] = useState(field["x-displayWidth"] || "");

  // 🔄 Synchronisation ascendante vers FormBuilder
  useEffect(() => onChange("minLength", min), [min]);
  useEffect(() => onChange("maxLength", max), [max]);
  useEffect(() => onChange("pattern", pattern), [pattern]);
  useEffect(() => onChange("x-placeholder", placeholder), [placeholder]);
  useEffect(() => onChange("x-displayWidth", displayWidth), [displayWidth]);

  return (
    <>
      <CommonControls field={field} onChange={onChange} />

      {/* ---- Longueurs ---- */}
      <div className="mb-3">
        <label className="form-label">Longueur minimale</label>
        <input
          type="number"
          className="form-control form-control-sm compact"
          value={min}
          onChange={(e) => setMin(Number(e.target.value))}
          placeholder="ex : 5"
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Longueur maximale</label>
        <input
          type="number"
          className="form-control form-control-sm compact"
          value={max}
          onChange={(e) => setMax(Number(e.target.value))}
          placeholder="ex : 255"
        />
      </div>

      {/* ---- Motif de validation ---- */}
      <div className="mb-3">
        <label className="form-label">Motif de validation (regex)</label>
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="ex : ^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$"
          value={pattern}
          onChange={(e) => setPattern(e.target.value)}
        />
        <small className="text-muted">
          Optionnel — pour restreindre le format autorisé (regex JavaScript).
        </small>
      </div>

      {/* ---- Placeholder ---- */}
      <div className="mb-3">
        <label className="form-label">Texte indicatif (placeholder)</label>
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="ex : contact@exemple.fr"
          value={placeholder}
          onChange={(e) => setPlaceholder(e.target.value)}
        />
      </div>

      {/* ---- Largeur visuelle ---- */}
      <div className="mb-3">
        <label className="form-label">Largeur du champ (en caractères)</label>
        <input
          type="number"
          className="form-control form-control-sm compact"
          placeholder="ex : 40"
          value={displayWidth}
          onChange={(e) => setDisplayWidth(e.target.value)}
        />
      </div>
    </>
  );
}

/**
 * Compatibilité avec le FieldEditorRegistry
 */
export const editEmailField = (props) => <EditEmailField {...props} />;


/* =========================================================
   🧩 FRONT — rendu du champ e-mail
   ========================================================= */
export const RenderEmailField = ({
  field,
  value,
  onChange,
  className,
  isReadOnly,
  errors     // <--- AJOUT
}) => {

  const placeholder = field["x-placeholder"] || "";
  const minLength = field.minLength ?? 0;
  const maxLength = field.maxLength ?? 255;
  const pattern = field.pattern || "";
  const inputMode = field["x-inputMode"] || "email";
  const displayWidth = field["x-displayWidth"] || "";
  const required = field.required || false;
  const isRequired =
    field["x-effective-required"] === true ||
    field["x-required"] === true;
  return (
    <div
      className={`
        fb-field fb-email
        ${isRequired ? "fb-required" : ""}
        ${field["x-bloc-class"] || ""}
        ${className || ""}
      `}
    >

      {/* Label */}
      {field.title && (
        <label className={`form-label`}>
          {field.title}
        </label>
      )}

      {/* Input email */}
      <input
        type="email"
        className={`
          form-control
          ${isRequired ? "fb-required" : ""}
          ${field["x-control-class"] || ""}
          ${errors ? "is-invalid" : ""}
        `}
        placeholder={placeholder}
        inputMode={inputMode}
        minLength={minLength}
        maxLength={maxLength}
        pattern={pattern}
        size={displayWidth || undefined}
        readOnly={isReadOnly}
        value={value || ""}
        onChange={(e) => onChange?.(e.target.value)}
      />

      {/* Message d’erreur */}
      {/* errorMessage && (
        <div className="invalid-feedback d-block mt-1">
          {errorMessage}
        </div>
      ) */}

    </div>
  );
};
